'use client';

import * as React from 'react';
import * as SeparatorPrimitive from '@radix-ui/react-separator';

import { cn } from '@/hen-ui/utils/index';

/**
 * Shadcn Separator base: wraps Radix Separator with EDU design tokens.
 * Color is the semantic divider role, with the legacy neutral fallback.
 * Cross-axis size lives on the HEN Separator so a thickness choice replaces
 * the hairline instead of sitting beside it.
 * Radix handles ARIA: decorative=true → aria-hidden; decorative=false → role="separator"
 */
const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>
>(
  (
    { className, orientation = 'horizontal', decorative = true, ...props },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn('shrink-0 bg-border-divider', className)}
      {...props}
    />
  ),
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
